import { Box, Grid, TextField, Typography, MenuItem, Divider, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import SelectWithInput from '../SelectWithInput';
import { getBranchById, getUserById } from '../../../../utilities/common';

const useStyles = makeStyles((theme)=> ({
  section: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  bottomSubmit: {
    display: 'flex', 
    justifyContent: 'center',
    padding: theme.spacing(4),
  }
}))

function BasicInformationForm(props) {
  const classes = useStyles();
  const {t} = useTranslation('incidentManagement');

  const { data, branchList, userList, statusList, onFormChange, onTrackingNumberChange} = props;
  const { incidentLevelList, incidentTypeList, sourceList } = statusList;

  return (
    <Box>
      <Typography variant='h5'>{t('basic_information')}</Typography>
      <form>
        <Grid container spacing={4} className={classes.section}>
          <Grid item xs={6}>
            <TextField
              id='select-incident-level'
              name="level"
              label={t('incident_level')}
              variant='outlined'
              value={data.level}
              onChange={onFormChange}
              select
              fullWidth
            >
              {incidentLevelList.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={6}>
            <TextField
              label={t('investigation_status')}
              variant='outlined'
              fullWidth
              disabled
              defaultValue="Opened"
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label={t('record_time')}
              variant='outlined'
              fullWidth
              disabled
              defaultValue={moment.unix(data.record_time).format("YYYY-MM-DD")}
            />
          </Grid>
        </Grid>
        <Divider />
        <Grid container spacing={4} className={classes.section}>
          <Grid item xs={6}>
            <TextField
              id='input-tracking-number'
              name='tracking_no'
              label={t('common:tracking_number')}
              variant='outlined'
              value={data.tracking_no}
              onChange={onFormChange}
              onBlur={(event)=>{
                onTrackingNumberChange(event.target.value)
              }}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id="date-of-occurrence"
              label={t("occurrence_time")}
              name="occurrence_time"
              type="date"
              variant="outlined"
              value={moment.unix(data.occurrence_time).format("YYYY-MM-DD")}
              onChange={onFormChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label={t('common:location')}
              variant='outlined'
              value={getBranchById(data.location, branchList)?.name || "Unknown"}
              fullWidth
              disabled
            />
          </Grid>
        </Grid>
        <Divider />
        <Grid container spacing={4} className={classes.section}>
          <Grid item xs={6}>
            <TextField
              label={t('recorded_by')}
              variant='outlined'
              defaultValue={getUserById(data.recorded_by, userList)?.username || data.recorded_by}
              fullWidth
              disabled
            />
          </Grid>
          <SelectWithInput
            selectGridProps={{item: true, xs:6}}
            inputGridProps={{item: true, xs:12}}
            selectArray={sourceList}
            selectLabel={t('start_from')}
            inputLabel={t('other_source')}
            selectName='source'
            inputName='other_source'
            selectValue={data.source}
            inputValue={data.other_source}
            handleChange={onFormChange}
            selectRequired
          />
          <SelectWithInput 
            selectGridProps={{item: true, xs:6}}
            inputGridProps={{item: true, xs:12}}
            selectArray={incidentTypeList}
            selectLabel={t('incident_type')}
            inputLabel={t('other_incident_type')}
            selectName='incident_type'
            inputName='detail'
            selectValue={data.incident_type}
            inputValue={data.detail}
            handleChange={onFormChange}
            selectRequired
          />
          <Grid item xs={12}>
            <TextField
              id="input-notes"
              label={t('notes')}
              name="notes"
              variant='outlined'
              defaultValue={data.notes}
              multiline
              onChange={onFormChange}
              rows={4}
              fullWidth
            />
          </Grid>
        </Grid>
      </form>
    </Box>
  )
}

export default BasicInformationForm